export default __webpack_public_path__ + "static/media/pro_2.697346e3.jpg";